import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import UUID from "uuid/v4";
import Loader from "react-loader-advanced";
import CircularProgress from "material-ui/CircularProgress";
import ReactS3Uploader from "react-s3-uploader";
import { StyledDropZone } from "react-drop-zone";
import "../../resources/styles/VideoPicker.css";

import Config from "../../config";
import { createRequestOptions } from "../../services/utils";
import S3Upload from "react-s3-uploader/s3upload.js";
import colors from "../../styles/colors";

import { isMobile } from "react-device-detect";

const style = {
  header: {
    margin: 5,
    fontSize: 16,
    color: colors.primary,
    fontFamily: "Poppins-Regular",
  },
  text: {
    fontSize: 12,
    color: colors.primary,
    fontFamily: "Poppins-Regular",
    margin: 0,
  },
};

class FilePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileUrl: !_.isEmpty(props.fileUrl) ? props.fileUrl : "",
      isUploading: false,
      progress: 0,
      error: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      fileUrl: nextProps.fileUrl,
    });
  }

  render() {
    let fileName =
      "documents/" +
      this.props.userId +
      "/" +
      this.props.appId +
      "/" +
      UUID() +
      "_";

    const getSignedUrl = (file, callback) => {
      let userId = this.props.userId;
      let bucketName = Config.s3.bucket;
      fileName = fileName + file.name;
      let objectKey = fileName;
      let contentType = file.type;
      const options = createRequestOptions({
        userId,
        bucketName,
        objectKey,
        contentType,
      });
      fetch(Config.serverUrl + "/GetS3SignedUrl", options)
        .then((response) => response.json())
        .then((responseJson) => {
          let ret = _.get(responseJson, "response");
          let signedUrl = _.replace(ret.signedUrl, "http://", "https://");
          let result = {
            signedUrl,
            fileName,
            publicUrl: "/s3/uploads/" + fileName,
            fileKey: fileName,
          };
          callback(result);
        })
        .catch((error) => {
          console.error("Error getting signed url: " + error);
          this.setState({
            isUploading: false,
            error: "Error uploading the file: signed url",
          });
        });
    };

    const uploadFile = async (file) => {
      let upload = new S3Upload({
        files: [file],
        getSignedUrl,
        onProgress: onProgress,
        onFinishS3Put: onFinish,
      });
    };

    // preprocess
    const preprocess = (file, next) => {
      if (file.size > 10485760) {
        this.setState({
          isUploading: false,
          error: "File is too big. Max size 10M.",
        });
      } else {
        return next(file);
      }
    };

    // Progress
    const onProgress = (percent, message) => {
      this.setState({ progress: percent });
      if (!this.state.isUploading && percent < 100) {
        this.setState({ isUploading: true });
      }
    };
    const $progressBar = (
      <div style={{ margin: 40 }}>
        <CircularProgress mode="determinate" value={this.state.progress} />
      </div>
    );
    let showProgress = this.state.progress > 0 && this.state.progress < 100;

    // error
    const onError = (message) => {
      this.setState({
        isUploading: false,
        error: "Error uploding the file: " + message,
      });
    };

    // finish
    const onFinish = (data) => {
      let fileUrl = Config.s3.s3Url + "/" + data.fileName;
      this.setState({
        isUploading: false,
        fileUrl,
      });
      this.props.handleSubmit(data.fileName, fileUrl);
    };

    return (
      <div style={style.container}>
        <div
          className={"video-picker-box"}
          style={{ paddingTop: "15px", paddingBottom: "60px" }}
        >
          <Loader show={this.state.isUploading} message={"Uploading file..."}>
            {!!!isMobile && (
              <StyledDropZone
                onDrop={(file, text) => uploadFile(file)}
                accept=".pdf, .csv, .doc, .docx., .jpeg, .jpg, .bmp,.png, .mp3"
                className={"video-picker-box-dropzone"}
              >
                <h3 style={style.header}>Upload Other Files</h3>
                <p style={style.text}>
                  Drag and Drop Document or <u>Click HERE to Browse</u>
                  <p>
                    Supported file types include: .pdf, .csv, .doc, .docx,
                    .jpeg, .jpg, .bmp, .mp3 and .png
                  </p>
                </p>
              </StyledDropZone>
            )}
            {!!isMobile && (
              <div style={{ width: "100%", textAlign: "center" }}>
                <h3 style={style.header}>Upload Document File</h3>
                <p style={style.text}>Select a document to upload</p>
                <input
                  type="file"
                  accept=".pdf, .csv, .doc, .docx. .jpeg, .jpg, .bmp,.png,.mp3"
                  onChange={(event) => {
                    uploadFile(event.target.files[0]);
                  }}
                />
              </div>
            )}
            {!_.isEmpty(this.state.error) && (
              <div style={{ color: "red" }}>{this.state.error}</div>
            )}
          </Loader>
        </div>
      </div>
    );
  }
}

FilePicker.propTypes = {
  fileUrl: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  appId: PropTypes.string.isRequired,
};

export default FilePicker;



// WEBPACK FOOTER //
// ./src/components/common/FilePicker.js